import { useState, useEffect } from "react";
import axios, { AxiosRequestConfig } from "axios";
import { useNavigate } from "react-router-dom";
import { Cookies } from "react-cookie";

axios.defaults.baseURL = "https://studenttracker.sc.chula.ac.th/studenttrackerapi"
// axios.defaults.baseURL = "https://cache111.com/studenttrackerapi"
// axios.defaults.baseURL = "http://localhost:5140"

export const useFetch = (axiosParams: AxiosRequestConfig, ...triggerArgs: any) => {

    const [data, setData] = useState<any>(null)
    const [status, setStatus] = useState<any>(null)
    const [error, setError] = useState<any>(null)
    const [loading, setLoading] = useState<boolean>(false)

    let navigate = useNavigate()
    const cookies = new Cookies()

    const DELAY_TIME = 300

    const fetchData = async (params: AxiosRequestConfig<any>) => {
        setLoading(true)
        await axios(params)
            .then((res) => {
                setData(res.data)
                setStatus(res.status)
                setError(null)
            })
            .catch((err) => {
                setError(err.response?.data || err.message)
                setStatus(err.response?.status)
                setData(null)

                if (err.response?.status === 401) {
                    cookies.remove('user', { path: '/' })
                    navigate('/')
                }
            }).finally(() => {
                setTimeout(() => {
                    setLoading(false)
                }, DELAY_TIME)
            }
        )
    }

    useEffect(() => {
        fetchData({
            ...axiosParams,
        })
    }, triggerArgs);

    return { data, status, error, loading }
};